'use client'
import { ThemeProvider as LibThemeProvider } from 'next-themes'

import type { PropsWithChildren } from 'react'

export const ThemeProvider = ({ children }: PropsWithChildren) => (
  <LibThemeProvider defaultTheme="light" attribute="class">
    {children}
  </LibThemeProvider>
)
